// constants/cardFonts.js - Font Constants for Greeting Cards

export const CARD_FONTS = [
  {
    id: 'default',
    name: 'Default',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    category: 'system',
    preview: 'Aa',
  },
  {
    id: 'pacifico',
    name: 'Pacifico',
    fontFamily: 'Pacifico-Regular',
    file: 'Pacifico-Regular.ttf',
    category: 'funky',
    preview: 'Aa',
  },
  {
    id: 'butcherman',
    name: 'Butcherman',
    fontFamily: 'Butcherman-Regular',
    file: 'Butcherman-Regular.ttf',
    category: 'bold',
    preview: 'Aa',
  },
  {
    id: 'carattere',
    name: 'Carattere',
    fontFamily: 'Carattere-Regular',
    file: 'Carattere-Regular.ttf',
    category: 'elegant',
    preview: 'Aa',
  },
  {
    id: 'estonia',
    name: 'Estonia',
    fontFamily: 'Estonia-Regular',
    file: 'Estonia-Regular.ttf',
    category: 'elegant',
    preview: 'Aa',
  },
  {
    id: 'pinyon',
    name: 'Pinyon Script',
    fontFamily: 'PinyonScript-Regular',
    file: 'PinyonScript-Regular.ttf',
    category: 'elegant',
    preview: 'Aa',
  },
  {
    id: 'hanalei',
    name: 'Hanalei Fill',
    fontFamily: 'HanaleiFill-Regular',
    file: 'HanaleiFill-Regular.ttf',
    category: 'funky',
    preview: 'Aa',
  },
  {
    id: 'eater',
    name: 'Eater',
    fontFamily: 'Eater-Regular',
    file: 'Eater-Regular.ttf',
    category: 'bold',
    preview: 'Aa',
  },
  {
    id: 'unifraktur',
    name: 'UnifrakturMaguntia',
    fontFamily: 'UnifrakturMaguntia-Regular',
    file: 'UnifrakturMaguntia-Regular.ttf',
    category: 'bold',
    preview: 'Aa',
  },
];

export const getFontById = (id) => {
  return CARD_FONTS.find(font => font.id === id) || CARD_FONTS[0];
};

export const getFontsByCategory = (category) => {
  if (!category) return CARD_FONTS;
  return CARD_FONTS.filter(font => font.category === category);
};

export default CARD_FONTS;
